export default {"src":"/polygon/_next/static/media/bannerImageMobile.56a5c1a0.svg","height":181,"width":182};